import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Style from 'app/themes/MoreInfoButton.module.scss';
import MoreInfo from './Overlays';

class MoreInfoButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFullScreen: false,
    };

    this.toggleFullScreen = this.toggleFullScreen.bind(this);
    this.renderMoreInfoOverlay = this.renderMoreInfoOverlay.bind(this);
  }

  toggleFullScreen() {
    const { showFullScreen } = this.state;
    this.setState({ showFullScreen: !showFullScreen });
  }

  renderMoreInfoOverlay() {
    const { description, ariaHidden } = this.props;
    const { showFullScreen } = this.state;

    const overlay = (
      <MoreInfo rendered innerContainerChildren={() => {}}>
        <div className={Style.overlay}>
          <div className={Style.header}>About</div>
          <div>{description}</div>
          <Link
            className={Style.actionButton}
            onClick={this.toggleFullScreen}
            aria-hidden={ariaHidden}
          >
            Close
          </Link>
        </div>
      </MoreInfo>
    );
    return showFullScreen ? overlay : null;
  }

  render() {
    const { className, value } = this.props;

    return (
      <div className={Style.outerContainer}>
        <Link className={className} onClick={this.toggleFullScreen} role="button">
          {value}
        </Link>
        {this.renderMoreInfoOverlay()}
      </div>
    );
  }
}

MoreInfoButton.defaultProps = {
  className: null,
  description: null,
  value: null,
  ariaHidden: false,
};

MoreInfoButton.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  ariaHidden: PropTypes.string,
};

export default MoreInfoButton;
